import React, { ReactNode, useState } from 'react';
import { useSelector } from 'react-redux';
import {
  selectMemberDeletionStatusData,
  selectMemberDeletionStatusLoading,
} from 'features/member/reducer/memberDetailSlice';
import InformModal from 'components/common/modal/InformModal';
import { Button, Typography } from '@material-ui/core';

const CheckAccountDeletionButton = () => {
  const [isDeleteInformModalOpen, setIsDeleteInformModalOpen] = useState<boolean>(false);
  const isLoading = useSelector(selectMemberDeletionStatusLoading);
  const { canDeleteAccount, nonDeletableProducts } = useSelector(selectMemberDeletionStatusData);
  const onInformModalClose = () => {
    setIsDeleteInformModalOpen(false);
  };

  const deleteInformMessage = (): ReactNode => {
    if (canDeleteAccount) {
      return <Typography variant={'subtitle1'}>Deletion Enabled</Typography>;
    }
    return (
      <>
        <Typography variant={'subtitle1'}>Deletion Disabled</Typography>
        <Typography variant={'body1'}>
          Reasons for not being able to delete: {nonDeletableProducts.join(', ')}
        </Typography>
      </>
    );
  };

  return (
    <>
      <InformModal
        open={isDeleteInformModalOpen}
        onClose={onInformModalClose}
        description={deleteInformMessage()}
        maxWidth={'sm'}
        type={canDeleteAccount ? 'notice' : 'error'}
      />
      <Button
        variant={'contained'}
        size={'small'}
        color={'primary'}
        onClick={() => setIsDeleteInformModalOpen(true)}
        disabled={isLoading}
      >
        Check Account Deletion {isLoading && '(Loading)'}
      </Button>
    </>
  );
};

export default CheckAccountDeletionButton;
